var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 69,
    viewBox: "0 0 71 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 67.5C16.4 67.5 20.4 63.5 20.4 58.6C20.4 53.7 16.4 49.7 11.4 49.7C6.40002 49.7 2.40002 53.7 2.40002 58.6C2.50002 63.5 6.50002 67.5 11.4 67.5ZM11.4 19.5C16.4 19.5 20.4 15.5 20.4 10.5C20.4 5.5 16.4 1.5 11.4 1.5C6.40002 1.5 2.40002 5.5 2.40002 10.5C2.50002 15.5 6.50002 19.5 11.4 19.5ZM37 26H10.9C6.30002 26 2.50002 29.8 2.50002 34.4V34.7C2.50002 39.3 6.30002 43.1 10.9 43.1H37C41.6 43.1 45.4 39.3 45.4 34.7V34.4C45.5 29.7 41.7 26 37 26ZM60.7 2.3H34.6C30 2.3 26.2 6.1 26.2 10.7V11C26.2 15.7 30 19.4 34.6 19.4H60.7C65.3 19.4 69.1 15.6 69.1 11V10.7C69.1 6.1 65.3 2.3 60.7 2.3Z",
    stroke: "#0A283F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8 49.6C40.8 49.6 44.8 53.6 44.8 58.5C44.8 63.4 40.8 67.4 35.8 67.4C30.8 67.4 26.8 63.4 26.8 58.5C26.8 53.6 30.8 49.6 35.8 49.6Z",
    stroke: "#0A283F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1 49.6C65 49.6 69.1 53.6 69.1 58.5C69.1 63.4 65.1 67.4 60.1 67.4C55.1 67.4 51.1 63.4 51.1 58.5C51.1 53.6 55.2 49.6 60.1 49.6Z",
    stroke: "#0A283F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1 25.2C65 25.2 69.1 29.2 69.1 34.2C69.1 39.2 65.1 43.1 60.1 43.1C55.1 43.1 51.1 39.1 51.1 34.2C51.1 29.3 55.2 25.2 60.1 25.2Z",
    stroke: "#0A283F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7004e150c9043b5eef6997d73f5bf2e2.svg";
export { ForwardRef as ReactComponent };